import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { bool, func, number } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Line } from '../Line';
import { Modal } from '../Modal';

const CertificationModalLayout = ({
  courseId,
  id,
  isVisible,
  setIsVisible,
}) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { isMobile, isTabletSM } = useScreenSize();

  const handlePassLater = () => {
    setIsVisible(false);
  };

  const handlePassNow = () => {
    navigate(`/courses/${courseId}/certification`, { state: { id } });
  };

  return (
    <Modal
      firstButtonProps={{
        color: theme.colors.white[100],
        maxWidth: isMobile ? '100%' : 245,
        py: 22,
        variant: 'secondary',
        width: '100%',
      }}
      firstButtonText={i18n.t('Certification.Modal.PassLater').toUpperCase()}
      isVisible={isVisible}
      modalContainerProps={{
        backgroundColor: theme.colors.white[10],
        border: `1px solid ${theme.colors.white[10]}`,
        borderRadius: '0px',
        ...(isTabletSM && { height: '100%' }),
        maxHeight: isTabletSM ? '100%' : '715px',
      }}
      {...(isTabletSM && { modalMaxHeight: '100%' })}
      onFirstButtonClick={handlePassLater}
      onSecondButtonClick={handlePassNow}
      secondButtonProps={{
        maxWidth: isMobile ? '100%' : 245,
        py: 22,
        variant: 'primary',
        width: '100%',
      }}
      secondButtonText={i18n.t('Certification.Modal.PassNow').toUpperCase()}
      setModalVisible={setIsVisible}
      withBackdropNoise
      withBottomButtons
    >
      <Flex
        flexDirection="column"
        gap={isMobile ? 16 : 24}
        p={isMobile ? 16 : 40}
        pt={isMobile ? 56 : 40}
      >
        <Typography
          color={theme.colors.white[100]}
          variant="BN-regular-s36-lh43"
        >
          {i18n.t('Certification.Modal.Title')}
        </Typography>
        <Line />
        <Typography
          color={theme.colors.alto[100]}
          variant="MS-regular-s16-lh25"
        >
          {i18n.t('Certification.Modal.Text')}
        </Typography>
      </Flex>
    </Modal>
  );
};

CertificationModalLayout.propTypes = {
  courseId: number.isRequired,
  id: number.isRequired,
  isVisible: bool.isRequired,
  setIsVisible: func.isRequired,
};

export default CertificationModalLayout;
